module.exports = function() {
  return new Worker(__webpack_public_path__ + "1ce61a48c9f169c95ace.worker.js");
};